import template from './ztr-date-picker.html';
import moment from 'moment';

class ZTRDatePickerController {
  constructor($timeout) {
    'ngInject';
    this.datepickerOptions = {};
    this.$timeout = $timeout;
  }

  $onInit() {
    this.setDatepickerOptions();
    this.onPickerOpen();
    this.validateInputs();
  }

  $onChanges() {
    this.onPickerOpen();
    this.setDatepickerOptions();
    this.validateInputs();
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
  }

  onPickerOpen() {
    if (this.isOpen && typeof this.onOpen === 'function') {
      this.onOpen();
    }
  }
  onDateChange() {
    //$timeout is important to delay onchang one cycle so ng-model will be updateed in the parent scope.
    this.$timeout(() => {
      if (typeof this.onChange === 'function') {
        this.onChange();
      }
    });
  }

  setDatepickerOptions() {
    this.inputName = this.inputName || 'datepicker';
    this.datepickerOptions = this.datepickerOptions || {};
    this.datepickerOptions = {
      ...this.datepickerOptions,
      maxDate: (this.maxDate ? moment(this.maxDate).toDate() : this.datepickerOptions.maxDate) || null,
      minDate: (this.minDate ? moment(this.minDate).toDate() : this.datepickerOptions.minDate) || null
    };
  }

  validateInputs() {
    /* eslint-disable no-console */
    if (this.onOpen && typeof this.onOpen !== 'function') {
      console.warn(`ztr-date-picker: on-open (${this.onOpen}) is not a function for ${this.inputName}`);
    }
    if (this.onChange && typeof this.onChange !== 'function') {
      console.warn(`ztr-date-picker: on-change (${this.onChange}) is not a function for ${this.inputName}`);
    }
    if (this.selectedDate && !moment(this.selectedDate).isValid()) {
      console.warn(`ztr-date-picker: ng-model (${this.selectedDate}) is not a valid date for ${this.inputName}`);
    }
    if (this.minDate && !moment(this.minDate).isValid()) {
      console.warn(`ztr-date-picker: min-date (${this.minDate}) is not a valid date for ${this.inputName}`);
    }
    if (this.maxDate && !moment(this.maxDate).isValid()) {
      console.warn(`ztr-date-picker: max-date (${this.maxDate}) is not a valid date for ${this.inputName}`);
    }
    /* eslint-enable no-console */
  }
}

export default {
  template,
  bindings: {
    selectedDate: '=ngModel',
    isOpen: '=isOpen',
    isRequired: '<?isRequired',
    onChange: '&?',
    datepickerOptions: '=?datepickerOptions',
    minDate: '<?minDate',
    maxDate: '<?maxDate',
    onOpen: '&onOpen',
    inputName: '<?inputName',
    disabled: '<disabled',
    placeHolder: '@'
  },
  controller: ZTRDatePickerController,
  controllerAs: 'vm'
};
